import React from 'react';
import { Modal } from '../ui/Modal';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';

const RushModeModal = ({ restaurant, isOpen, onClose }) => {
  const { language } = useDataContext();

  if (!isOpen) return null;

  // Support dynamic colors from restaurant settings
  const accentColor = restaurant?.ButtonColor || restaurant?.PrimaryColor || '#ef4444';

  return (
    <Modal isOpen={isOpen} onClose={onClose} contentClassName="max-w-[420px]">
      <div className="pt-8 px-6 pb-6">
        <div className="text-center mb-5">
          <div
            className="w-[72px] h-[72px] rounded-full flex items-center justify-center mx-auto mb-5"
            style={{
              background: `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}dd 100%)`,
              boxShadow: `0 4px 16px ${accentColor}44`,
            }}
          >
            <span className="text-3xl">🔥</span>
          </div>
          <h3 className="text-xl font-bold text-[#1a1a1a] mb-2">
            {restaurant?.RushModeHeader || translations[language]?.rush_mode_title || 'Bemærk'}
          </h3>
          <p className="text-sm text-gray-500 leading-snug">
            {restaurant?.RushModeMessage || translations[language]?.rush_mode_message || ''}
          </p>
        </div>

        <button
          onClick={onClose}
          className="w-full py-[14px] text-[15px] font-semibold text-white border-none rounded-xl cursor-pointer transition-opacity duration-200 hover:opacity-90"
          style={{ background: accentColor }}
        >
          {translations[language]?.understood || translations[language]?.close || 'Forstået'}
        </button>
      </div>
    </Modal>
  );
};

export default RushModeModal;
